exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectBorder[data-v-68b1eb9a]  .el-input__inner{border:none}.selectBorder input[data-v-68b1eb9a]::-webkit-input-placeholder{color:red}.selectBorder input[data-v-68b1eb9a]::-moz-placeholder{color:red}.selectBorder input[data-v-68b1eb9a]:-ms-input-placeholder{color:red}.selectBorder input[data-v-68b1eb9a]::-ms-input-placeholder{color:red}.selectBorder input[data-v-68b1eb9a]::placeholder{color:red}.test[data-v-68b1eb9a]  .el-radio-button__inner{background:none;border:none;color:red}", ""]);

// exports
